import Vue from 'vue'
// i18n国际化
import i18n from '@/assets/lang/index'
import ElementUI, { Message } from 'element-ui'
import qs from 'qs'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import axios from './service/index'
// import wsAxios from './service/wsAxios.js'
import store from './store'

import creatWebsocket from '@/assets/js/common/creatWebsocket'
import '@/assets/js/socket.io.js'
import '@/assets/js/webrtcClient.js'
import '@/assets/js/wp.js'
import '@/assets/iconfont/iconfont.js'

import '../theme/index.css'
import '@/assets/css/setting.less'
import '@/assets/css/googleMap.css'


/*
 * 注册全局指令
 * 滚动加载
 */
import Scroll from '@/directive/scroll'
// 过滤特殊字符
import FilterSpecialChar from '@/directive/filterSpecialChar'
// 节流
import repeatClick from '@/directive/repeatClick'

import CopySomething from '@/directive/copySomething'


import noEmoji from '@/directive/noEmoji'

import '@/directive/inputValScope'
import { ServiceShareInfo } from 'tvu-common-ui'

// global css
import '@/assets/css/index.less'
import deviceInfo from '@/assets/js/common/handleDeviceInfo'
import VueClipboard from 'vue-clipboard2'


// import { TopHeader } from 'tvu-common-ui'

import filters from '@/assets/js/filters'

// Vue.use(TopHeader)
Vue.use(Scroll)
Vue.use(FilterSpecialChar)
Vue.use(repeatClick)
Vue.use(noEmoji)
Vue.use(CopySomething)


window.Vue = Vue
Vue.use(VueClipboard)
Object.keys(deviceInfo).forEach(key => Vue.filter(key, deviceInfo[key]))
// 遍历注册全局过滤器
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))
Vue.use(ElementUI, {
  i18n: (key, val) => i18n.t(key, val) // 用于elementUI插件的中英文翻译
})

// 定义一个新的Message方法，多传入一个offset参数
const $message = options => {
  return Message({
    ...options,
    offset: 55
  })
}

// 重写一遍success的方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 55
      }
    }
    options.type = type
    return Message(options)
  }
})
// 将$message挂载到this上
Vue.prototype.$message = $message
Vue.prototype.$store = store
Vue.prototype.$tvuServiceShareInfo = ServiceShareInfo

// 供集成的外部js使用
window.JSMessage = ElementUI.Message
window.JSConfirm = ElementUI.MessageBox

Vue.use(qs)
Vue.use(VueAxios, axios)
// Vue.use(wsAxios)
Vue.use(creatWebsocket)
Vue.config.productionTip = false
Vue.config.devtools = false
window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
